<div
  class="bar-container"
  *ngIf="profileProgress$ | async; let profileProgress"
>
  <div class="percentage-label">{{ profileProgress }}%</div>
  <div class="bar">
    <div class="progress" [ngStyle]="{ width: profileProgress + '%' }"></div>
  </div>
</div>
